<template lang="pug">
  .auth_modal(v-if="isAuthModalVisibility")
    v-icon(v-if="!isRegisterPage" @click="toggleAuthModal") mdi-close
    .auth_modal_img
      .auth_modal_img_border
        img(v-if="isRegisterPage" src="@/assets/register.png")
        img(v-else src="@/assets/authModal.png")
    .auth_modal_content
      h3 {{ $t('misc.auth.create.title') }}
      span 1. {{ $t('misc.auth.download.app.modal') }} 📥
      span 2. {{ $t('misc.auth.download.signUp') }} 🆕
      span 3. {{ $t('misc.auth.using.services') }} 🚀
    v-btn(v-if="isRegisterPage" depressed color="primary" @click="getDeepLink()") {{ $t('label.mpay.download') }}
    v-btn(v-else depressed color="primary" @click="getDeepLink()" class="mb-5") {{ $t('misc.auth.sign.app') }}
</template>
<script>

export default {
  name: 'AppFrame',
  props: {
    isAuthModalVisibility: {
      type: Boolean,
      required: false,
    },
    isRegisterPage: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      value: 'https://sbplus.mpay.az/mpay-link',
      size: 202,
      userAgent: window.navigator.userAgent,
    };
  },
  methods: {
    toggleAuthModal() {
      this.$emit('closeAuthModal');
    },
    getDeepLink() {
      if (this.userAgent.match(/iPhone/) || this.userAgent.match(/Android/)) {
        window.location.href = 'mpay://auth/register';
      }
      setTimeout(() => {
        if (this.userAgent.match(/iPhone/)) {
          window.location.href = 'https://apps.apple.com/us/app/mpay-e-wallet/id6450408051';
        } else if (this.userAgent.match(/Android/)) {
          window.location.href = 'https://play.google.com/store/apps/details?id=com.mpayapp';
        } else if (this.userAgent.match(/huawei/)) {
          window.location.href = 'https://appgallery.huawei.com/#/app/C109994723';
        }
      }, 500);
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/styles/auth.scss';
.auth_modal {
     display: none;
     padding: 50px;
     border-radius: 20px 20px 0 0;
     background: white;
     position: absolute;
     z-index: 10;
     width: 100%;
     left: 0;
     right: 0;
     bottom: -10px;
     &_img {
       display: flex;
       align-items: center;
       justify-content: center;
       padding-top: 24px;
       border-radius: 15px;
       border: 1px solid #F1F1F3;
       background: radial-gradient(42.65% 42.65% at 78.5% 54.18%, #C4D4E7 0%, #FAFAFA 100%);
       &_border {
         width: 172px;
         box-shadow: inset 0 2px 6px 0 rgba(17, 43, 69, .35), 0 -30px 0px -30px rgba(0, 0, 0, .3), 0 -5px 100px -20px rgba(50, 50, 93, .25);
         padding: 8px 9px 0 8px;
         background-color: #F6F9FC;
         border-radius: 20px 20px 0 0;
         img {
           width: 100%;
           display: flex;
         }
       }
     }
     &_content {
         margin: 24px 0 57px;
         h3 {
             font-family: Poppins;
             font-weight: 500;
             font-size: 16px;
             line-height: 150%;
             margin-bottom: 16px;
         }
        span {
            font-weight: 400;
            font-size: 14px;
            color: #4B4B4B;
            display: block;
            &:nth-child(2n){
                margin: 10px 0;
            }
        }
     }
     .v-btn {
         border-radius: 10px;
         height: 44px;
         width: 100%;
         box-sizing: border-box;
     }
     .v-icon {
         display: flex;
         justify-content: end;
         align-items: center;
         margin-bottom: 32px;
         width: 100%;
     }
}
@media (max-width: 800px) {
  .auth {
    &_modal {
      display: block;
    }
  }
}
@media (max-width: 700px) {
  .auth_modal {
    padding: 16px;
    .v-icon {
      margin-bottom: 12px;
    }
  }
}
</style>
